enum ClickableTextSectionEnum {
    ClinicalNote,
    Recalls,
    InboundFax,
    Messages,
    Tasks,
    QuebecObstetricalFile,
    OntarioObstetricalFile,
    BritishColumbiaObstetricalFile,
    PopulationBasedFunding,
    PrescriptionRenewalNotes,
    ResultNotes,
    FaxCoverSheet,
    PortalCommunications
}

export { ClickableTextSectionEnum };
